const activity = {
  activity: "活动", // translated
  activities: "活动", // translated
  dates: "日期", // translated
  location: "地点", // translated
  languages: "语言", // translated
  categories: "类别", // translated
  ticketOption: "门票选项", // translated
  numberOfRatings: "评分数", // translated
  meetingPointInfo: "集合点信息", // translated
  meetingPoint: "会面点", // translated
  meetingPoints: "集合地点", // translated
  providedBy: "由...提供", // translated
  expirationDate: "截止日期", // translated
  groupSize: "团体规模", // translated
  features: "特征", // translated
  basedOn: "基于", // translated
  reviewsFromVerCustomers: "来自已验证客户的评论", // translated
  excellent: "出色的", // translated
  great: "伟大的", // translated
  average: "平均的", // translated
  poor: "贫穷的", // translated
  bad: "坏的", // translated
  onlyBookedCustomersTooltip: "只有预订此活动的顾客才能发表评论", // translated
  noReviewsYet: "目前，还没有对此活动的评论。", // translated
  backToActivitiesList: "返回活动列表", // translated
  getPrices: "获取价格", // translated
  availabilityAndPrices: "供货情况和价格", // translated
  ticketOptions: "门票选项", // translated
  ticketInfo: "门票信息", // translated
  selectYourTickets: "选择您的门票", // translated
  product: "产品", // translated
  total: "全部的", // translated
  slot: "投币口", // translated
  language: "语言", // translated
  tickets: "门票", // translated
  ticketsFor: "门票为", // translated
  previousStep: "前一步", // translated
  onlyAvailableInEnglish: "仅提供英文版本", // translated
  guest: "客人", // translated
  leadGuest: "领衔嘉宾", // translated
  adult: "成人", // translated
  child: "孩子", // translated
  pleaseSelectAdult: "请至少选择一名成人", // translated
  notAvailableActivity: "本产品不可用", // translated
  required: "必需的", // translated
  pickupPoint: "接送点", // translated
  pickupPoints: "接送点", // translated
  ticketType: "门票类型", // translated
  anonymous: "匿名的", // translated
  printedVoucher: "接受打印凭证", // translated
  mobileVoucher: "接受移动优惠券", // translated
  mixedVoucher: "接受手机或打印的凭证", // translated
  safetyMeasures: "采取的安全措施", // translated
  doThisBecause: "这样做是因为", // translated
  safetyInfo: "安全信息", // translated
  reviewsHighestFirst: "评论数（最高的在前）", // translated
  bookingFee: "预订费", // translated
  startDate: "开始日期", // translated
  endDate: "结束日期", // translated
  cancellationDeadlineAndFees: "取消截止日期和费用", // translated
  resetTickets: "重置门票", // translated
  instantConfirmation: "即时确认", // translated
  clickResetBtn: "单击重置按钮重新开始您的选择", // translated
};


export default activity;
